import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const productPropertyUpdateSchema = z.object({
  product_ids: z.array(z.number()),
  updates: z.array(
    z.object({
      field: z.literal("tags"),
      action: z.union([z.literal("set"), z.literal("remove"), z.literal("add")]),
      value: z.string().array(),
    }),
  ),
});

export type ProductPropertyUpdateSchema = z.infer<typeof productPropertyUpdateSchema>;

export const productAdsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "bulkUpdateProductAdStatus",
    method: "put",
    path: "/gvads/productid/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          product_ids: z.array(z.number()),
          status: z.string(),
        }),
      },
    ],
    status: 204,
    response: z.void(),
  })
    .addEndpoint({
      alias: "updateProductAdStatus",
      method: "put",
      path: "/gvads/advproduct/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.union([
            z.object({
              custom_api_request: z.literal("pause_product_ad"),
              products: z.array(z.number()),
              ad_id: z.number(),
              state: z.string(),
            }),
            z.object({
              custom_api_request: z.literal("pause_product_ad"),
              id: z.number(),
              products: z.array(z.number()),
              state: z.number(),
            }),
          ]),
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "bulkUpdateProductProperties",
      method: "post",
      path: "/bulk_update_products/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: productPropertyUpdateSchema,
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .build(),
);
